require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-pietro-martinelli.json") })
        }
      }, "path---en-interviste-pietro-martinelli");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-pietro-martinelli!./.cache/json/en-interviste-pietro-martinelli.json
// module id = 596
// module chunks = 231608221292675